import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  // Original Logo URL
  const logoUrl = "https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/8ea8653d4b706808e30879bed312feb5.png";

  return (
    <section className="relative flex flex-col items-center justify-center min-h-screen pt-20 pb-16 overflow-hidden bg-emerald-950">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1565626423194-56c527e0eb1f?q=80&w=2000&auto=format&fit=crop" 
          alt="Industriegelände Heinsberg Luftaufnahme" 
          className="object-cover w-full h-full opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-950 via-emerald-950/80 to-emerald-900/40"></div>
      </div>

      <div className="container relative z-10 px-4 mx-auto md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="flex flex-col items-center"
          >
            {/* LOGO WITH 50PX OFFSET */}
            <div className="relative mb-28 px-4 translate-y-[50px]">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-white/5 blur-3xl rounded-full"></div>
              
              <img 
                src={logoUrl} 
                alt="Küppers Gewerbeeinheiten" 
                className="relative h-48 md:h-72 w-auto object-contain drop-shadow-[0_20px_50px_rgba(0,0,0,0.4)]"
                onError={(e) => {
                  console.error("Logo could not be loaded");
                  e.target.style.display = 'none';
                }}
              />
            </div>

            <span className="inline-block px-6 py-1.5 mb-8 text-xs font-bold tracking-[0.2em] text-yellow-500 uppercase border border-yellow-500/40 bg-yellow-500/5 rounded-full backdrop-blur-sm">
              Heinsberg | Waldhufenstrasse 9
            </span>

            <h1 className="mb-8 text-4xl font-extrabold leading-tight text-white md:text-7xl tracking-tight">
              Repräsentatives <br className="hidden md:block"/>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-500">
                Industriegelände
              </span>
            </h1>

            <p className="mb-8 text-lg leading-relaxed text-gray-300 md:text-2xl max-w-2xl mx-auto font-medium">
              Flexible Hallen und Büroflächen für Ihr Wachstum. <br className="hidden md:block"/>
              Entdecken Sie den Gewerbehof "Alte Schmiede".
            </p>

            {/* SWIPE DOWN / SCROLL INDICATOR - Above buttons */}
            <motion.div 
              className="flex flex-col items-center gap-2 mb-10"
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 2.5 }}
            >
              <div className="w-[24px] h-[40px] rounded-full border-2 border-white/20 flex justify-center p-1">
                <motion.div 
                  animate={{ opacity: [1, 0], y: [0, 10, 0] }}
                  transition={{ repeat: Infinity, duration: 1.5 }}
                  className="w-1.5 h-1.5 bg-yellow-500 rounded-full"
                ></motion.div>
              </div>
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/40">Scroll</span>
            </motion.div>

            {/* ACTION BUTTONS - Centered via flex-col on all screen sizes */}
            <div className="flex flex-col items-center gap-4 w-full sm:w-auto mb-10">
              <a 
                href="#hallenplan" 
                className="btn-accent text-lg px-12 py-5 w-full sm:w-80"
              >
                Verfügbare Einheiten
              </a>
              <a 
                href="#kontakt" 
                className="px-12 py-5 text-lg font-bold text-white transition-all duration-300 bg-white/5 border-2 border-white/20 rounded-sm hover:bg-white hover:text-emerald-950 backdrop-blur-md w-full sm:w-80"
              >
                Kontakt
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}